import { Rate } from 'antd';

const StarReview = (props) => <div className='star_review'><Rate disabled defaultValue={props?.value} style={{ fontSize: 36 }} /></div>;

export default StarReview;